export default __webpack_public_path__ + "static/media/pinterest.3909cf40.svg";